import _ from "lodash";
import { QUEUE_CHANNEL_FN } from './types';

export const setQueueChannelFnDefault = () => {
    return {
        type: QUEUE_CHANNEL_FN.SET_QUEUE_CHANNEL_FN_DEFAULT,
    }
}

export const setQueueChannelFn = (queueChannelFn) => {
    return {
        type: QUEUE_CHANNEL_FN.SET_QUEUE_CHANNEL_FN,
        queueChannelFn: queueChannelFn
    }
}

export const setQueueChannelFnValue = (draftType, orignalProduct, key, value, index) => {
    const queueChannelFn = _.cloneDeep(orignalProduct);
    switch (draftType) {
        default:
            queueChannelFn[draftType] = value;
    }
    return {
        type: QUEUE_CHANNEL_FN.SET_QUEUE_CHANNEL_FN_VALUE,
        queueChannelFn: queueChannelFn
    }
}

export const setQueueChannelFnResourcesStepsValue = (draftType, orignalProduct, key, value, index) => {

    const queueChannelFn = _.cloneDeep(orignalProduct);

    switch (draftType) {
        default:
            queueChannelFn.resourcesSteps[index] = value;
    }
    return {
        type: QUEUE_CHANNEL_FN.SET_QUEUE_CHANNEL_FN_VALUE,
        queueChannelFn: queueChannelFn
    }
}